<script>
import FooterSection from "../package/footerSection.vue";
import BreadcrumbSection from "../package/breadcrumbSection.vue";
import HeaderSection from "../package/HeaderSection.vue";
import ListingDetailsTabs from "../propertyDetails/listingDetailsTabs.vue";
import MeetAgent from "../propertyDetails/meetAgent.vue";
import MoreFromAgent from "../propertyDetails/moreFromAgent.vue";
import ListingDetails from "../propertyDetails/listingDetails.vue";
import ListingLocation from "../propertyDetails/listingLocation.vue";
import ReserveProperty from "../propertyDetails/reserveProperty.vue";
import FindOutMore from "../package/findOutMore.vue";
import ContactUs from "../package/contactUs.vue";
import AgentsRegistration from "../package/agentsRegistration.vue";
import ConnectingProperties from "../package/connectingProperties.vue";
import SocialSection from "../package/socialSection.vue";
import StayUpToDate from "../package/stayUpToDate.vue";
import discoverMore from "../package/discoverMore.vue";
import agentSignInSection from "../package/agentSignInSection.vue";
import BuyOffPlanSection from "../package/buyOffPlanSection.vue";
import TopImageSection from "../package/topImageSection.vue";
import SimilarProperties from "../search/similarProperties.vue";
import AdvertisementThree from "../search/advertisementThree.vue";
import AdvertisementOne from "../search/advertisementOne.vue";
import AdvertisementTwo from "../search/advertisementTwo.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import SearchSection from "../package/searchSection.vue";
import ViewMore from "../search/viewMore.vue";
import LoadMore from "../search/loadMore.vue";
import SearchingImageSection from "../search/searchingImageSection.vue";
import SearchResultsViewChange from "../search/searchResultsViewChange.vue";
import SearchResults from "../search/searchResults.vue";
import BreadcrumbContactUs from "./breadcrumbContactUs.vue";
import ContactUsImage from "./contactUsImage.vue";
import ContactUsSection from "./contactUsSection.vue";
import GotQuestions from "../package/gotQuestions.vue";
import EmailUsSectionLight from "./emailUsSectionLight.vue";
import DrawerAside from "../package/DrawerAside.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";

export default {
  name: "contactUsLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Contact Us";
  },
  created() {
    document.title = "UNIFI Property: Contact Us";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    }
  },
  components: {
    HeaderSection,
    EmailUsSectionLight,
    DrawerAside,
    GotQuestions,
    ContactUsImage,
    ContactUsSection,
    BreadcrumbContactUs,
    ReserveProperty,
    MoreFromAgent,
    ListingLocation,
    MeetAgent,
    ListingDetails,
    ListingDetailsTabs,
    FindOutMore,
    ContactUs,
    AgentsRegistration,
    ConnectingProperties,
    SocialSection,
    StayUpToDate,
    discoverMore,
    agentSignInSection,
    BuyOffPlanSection,
    TopImageSection,
    BreadcrumbSection,
    SimilarProperties,
    AdvertisementThree,
    AdvertisementOne,
    AdvertisementTwo,
    FooterSection,
    propertyIconSet,
    SearchSection,
    ViewMore,
    LoadMore,
    SearchingImageSection,
    SearchResultsViewChange,
    SearchResults,
    // MobileAppDownload
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-contact-us />
        <contact-us-section />
        <email-us-section-light />
<!--        <mobile-app-download/>-->
        <!-- Disabled for now -->
<!--        <agent-sign-in-section />-->

      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contactUsLayout.vue